
const ALENO_SCRIPT = 'https://mytools.aleno.me/reservations/v2.0/reservations.js';
const ALENO_STYLES = 'https://mytools.aleno.me/reservations/v2.0/reservations.css';
const WIDGET_BASE_URL =
  'https://mytools.aleno.me/reservations/v2.0/reservations.html?k=eyJrIjoid2l2dTVrM2lsNm15cnBiOWlwdzZ4bmViajhycnVkaWRpZ280bGZwODBsbzlhNGlweTEiLCJyIjoiY1pTbXJER3pKWUhYV2F4RUgiLCJzIjoiaHR0cHM6Ly9teXRvb2xzLmFsZW5vLm1lLyJ9';

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  head() {
    if (!this.data?.isActive) {
      return;
    }

    return {
      script: [{ src: ALENO_SCRIPT }],
      link: [{ rel: 'stylesheet', href: ALENO_STYLES }]
    };
  },

  computed: {
    widgetUrl() {
      return `${WIDGET_BASE_URL}&locale=${this.$i18n.locale}`;
    }
  },

  methods: {
    openWidget(event) {
      this.waitForAleno(() => {
        window.alenoPopup.show(event);
      });
    },

    waitForAleno(callback) {
      if (window.alenoPopup) {
        callback();
        return;
      }

      const interval = setInterval(() => {
        if (window.alenoPopup) {
          clearInterval(interval);
          callback();
        }
      }, 100);

      setTimeout(() => clearInterval(interval), 10000);
    }
  }
};
